module.exports = __webpack_public_path__ + "static/media/水体场景监测装置3.db2b011f.png";